module.exports = __webpack_public_path__ + "img/icon-whatsapp.48451ad1.svg";